module.exports = __webpack_public_path__ + "img/BET_logo_symbol.2cd42bde.png";